import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  webplayerBtn: {
    backgroundColor: ({ theme }) => theme.palette.button.primary,
    fontSize: "11px",
    color: ({ theme }) => theme.palette.text.primary,
    border: "2px solid #A8ABC2",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  webplayerWrapper: {
    width: "100%",
    height: "82vh",
    backgroundColor: "#fff",
    marginTop: "-2rem",
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    marginBottom: '-20px'
  },
  iframeWrapper: {
    backgroundColor: "#fff",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
  },
  backBtn: {
    marginRight: "2%",
    backgroundColor: "#8588A1",
    fontWeight: 700,
    fontSize: "12px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#8588A1",
    },
  },
  btnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  backIcon: {
    marginBottom: "1px",
  },
  iframe: {
    width: "100%",
    padding: ({ isWebPlayerExpanded }) =>
      isWebPlayerExpanded ? " 0px" : "10px",
    paddingTop: '3px',
    height: ({ isWebPlayerExpanded }) => isWebPlayerExpanded ? "100vh" : "78vh"
  },
  expandIcon: {
    backgroundColor: "#8588A1",
    "&:hover": {
      backgroundColor: "#8588A1",
    },
    color: "#fff",
    width: "30px",
    height: "35px",
  },
  parametricContainer: {
    display: ({ openPlayer }) => (openPlayer ? "none" : "flex"),
    height: '60vh'
  },
  tableWrapper: {
    height: "69vh",
    width: "100%",
    marginBottom: "4rem",
    marginTop: "2rem",
    "@media (max-height: 700px)": {
      height: "100%",
      marginTop: "0rem",
    },
  },

  tidNameWrapper: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    textAlign: "left",
  },
  shipLogo: {
    height: "23px",
    width: "23px",
  },
  loginButton: {
    marginTop: "10px",
    cursor: "pointer",
    color: "rgb(255, 255, 255)",
    fontSize: "12px",
    fontWeight: 500,
    backgroundColor: "rgb(133, 136, 161)",
    padding: "10px 16px",
    boxShadow:
      "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    minWidth: "64px",
    border: "none",
    borderRadius: "4px",
    textTransform: "uppercase",
  },
  loginLauncher: {
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "10px",
    padding: "20px",
    width: "500px",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 20px 0px",
  },
  loadingContainer: {
    marginTop: "10%",
    display: "flex",
    justifyContent: "center",
  },
  tidName: {
    fontSize: '1.2rem',
    marginTop: 5,
    marginLeft: "0.7rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
  },
  webplayerHeaderGrid: {
    paddingRight: "1%",
    paddingLeft: "1.5%",
    paddingTop: "5px",
  },
  detailsHeader: {
    marginLeft: "0.8vw",
  },

  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    borderRadius: "3px",
    boxShadow: "0px 1px 6px rgba(0,0,0,0.6)",
    padding: "25px",
  },

  modalHeaderContainer: {
    height: "40px",
    display: "flex",
    alignItems: "center",
  },

  modalHeader: {
    width: "100%",
    fontSize: "1.4vw !important",
    fontWeight: "600",
    textAlign: "center",
    color: ({ theme }) => theme.palette.text.primary,
  },

  modalHeaderIcon: {
    height: "35px",
    width: "35px",
    cursor: "pointer",
    fontSize: "15px",
    color: ({ theme }) => theme.palette.text.primary,
  },

  modalContentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    alignItems: "flex-start",
  },

  inputHeader: {
    fontSize: "0.8vw",
    fontWeight: "500",
    color: ({ theme }) => theme.palette.text.primary,
  },

  input: {
    height: "45px",
    width: "100%",
    fontFamily: "Rubik",
    fontSize: "0.8vw",
    fontWeight: 400,
    color: ({ theme }) => theme.palette.text.primary,
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    border: ({ theme }) => `1px solid ${theme.palette.text.primary}`,
    paddingInline: "10px",
    borderRadius: "3px",
  },

  modalBottomContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    marginTop: "10px",
  },

  actionsContainer: {
    display: "flex",
    gap: "10px",
    height: '100%',
    alignItems: 'center',
    width: '60%'
  },

  actionBtn: {
    backgroundColor: ({ theme }) => theme.palette.button.primary,
    color: ({ theme }) => theme.palette.text.primary,
    border: "2px solid #A8ABC2",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "transparent",
    },
    minWidth: "35px !important",
    height: "2.1rem",
    width: "2.1rem",
  },
  createBtn: {
    fontWeight: "600px",
    fontSize: "0.7vw",
    fontFamily: "Rubik",
    color: "#FFFFFF",
    backgroundColor: "#B80351",
    "&:hover": {
      backgroundColor: "#B80351",
    }
  },
  actionContainer: {
    width: "100%",
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    marginTop: '-35px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px'
  }
});
